module.exports = __webpack_public_path__ + "static/379f6d97.point.gif";